import React from 'react';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import {Route, Switch, withRouter} from 'react-router-dom';
import rawTheme from './../../../theme.json';
import PublicItemPage from "../explore/items/item-viewer/PublicItemPage";
import ExternalAppBar from "../../organisms/app-bar/ExternalAppBar";


const muiTheme = createTheme(rawTheme);

function View() {
  return (
    <ThemeProvider theme={muiTheme}>
      <ExternalAppBar />
      <Switch>
        <Route path="/view/item/:shareHash" component={props => <PublicItemPage {...props} />} />
      </Switch>
    </ThemeProvider>
  );
}

export default withRouter(View);
